document.addEventListener('DOMContentLoaded', function () {
  if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
    console.error('jQuery or Slick Slider not loaded.');
    return;
  }

  const $ = jQuery;

  // Fade in entire slider after DOM is loaded
  const $sliderContainer = $('.productView-images-wrapper');
  if ($sliderContainer.length === 0) {
    console.error('No .productView-images-wrapper element found in DOM');
    return;
  }
  console.log('.productView-images-wrapper element found, count:', $sliderContainer.length);
  console.log('Initial styles: display=', $sliderContainer.css('display'), 'opacity=', $sliderContainer.css('opacity'), 'visibility=', $sliderContainer.css('visibility'));
  setTimeout(function() {
    if (!$sliderContainer.hasClass('loaded')) {
      $sliderContainer.addClass('loaded');
      console.log('Slider container faded in');
    } else {
      console.log('Slider container already has .loaded class');
    }
  }, 0);

  try {
    // Check for thumbnail slider existence
    const $thumbnailSlider = $('.rk_column .productView-for');
    const hasThumbnailSlider = $thumbnailSlider.length > 0;

    // Initialize main slider
    const $mainSlider = $('.rk_column .productView-nav').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: hasThumbnailSlider,
      dots: false,
      adaptiveHeight: false,
      lazyLoad: 'ondemand',
      infinite: hasThumbnailSlider,
      asNavFor: hasThumbnailSlider ? '.rk_column .productView-for' : undefined,
      prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Previous"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>'
    });

    // Initialize thumbnail slider if present
    if (hasThumbnailSlider) {
      $thumbnailSlider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        centerMode: false,
        variableWidth: false,
        infinite: true,
        focusOnSelect: true,
        asNavFor: '.rk_column .productView-nav',
        slidesPerRow: 1,
        rows: 1,
        initialSlide: 0,
        prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Previous"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
              slidesPerRow: 1,
              rows: 1,
              infinite: true
            }
          }
        ]
      });

      // Handle thumbnail clicks
      $thumbnailSlider.on('click', '.productView-thumbnail', function() {
        let index = $(this).data('slick-index');
        const totalSlides = $thumbnailSlider.find('.productView-thumbnail').length;
        index = ((index % totalSlides) + totalSlides) % totalSlides;
        $mainSlider.slick('slickGoTo', index);
        $thumbnailSlider.find('.productView-thumbnail').removeClass('slick-current').find('img').css('opacity', '0.7');
        $(this).addClass('slick-current').find('img').css('opacity', '1');
        $thumbnailSlider.slick('slickGoTo', index, true);
      });

      // Initialize first thumbnail position
      $thumbnailSlider.find('.productView-thumbnail').removeClass('slick-current').find('img').css('opacity', '0.7');
      $thumbnailSlider.find('.productView-thumbnail').eq(0).addClass('slick-current').find('img').css('opacity', '1');
      $thumbnailSlider.slick('slickGoTo', 0, true);

      // Re-initialize position after a brief delay
      setTimeout(function() {
        $thumbnailSlider.slick('slickGoTo', 0, true);
      }, 1000);

      console.log('Recipe slider and thumbnail slider initialized');
    } else {
      console.log('Single image detected, thumbnail slider not initialized');
    }

    // Fancybox v3.5.7 initialization
    if (typeof $.fancybox === 'undefined') {
      console.error('Fancybox library not loaded. Ensure fancybox.js is included.');
      return;
    }

    const selector = '.rk_column .productView-nav .slick-slide:not(.slick-cloned) a[data-fancybox="blog-gallery"]';
    try {
      // Log Fancybox version
      console.log('Fancybox version:', $.fancybox.version || 'Unknown');

      // Disable Fancybox on cloned slides
      const disableClones = () => {
        const $clones = $('.rk_column .productView-nav .slick-cloned a[data-fancybox="blog-gallery"]');
        $clones.removeAttr('data-fancybox').addClass('fancybox-disabled');
        console.log('Cloned slides disabled, count:', $clones.length);
      };
      disableClones();

      // Re-disable clones on all Slick events
      $mainSlider.on('init reInit afterChange setPosition', disableClones);

      // Verify selector matches
      const $fancyboxElements = $(selector);
      console.log('Fancybox selector:', selector, 'elements found:', $fancyboxElements.length);
      $fancyboxElements.each(function(i) {
        console.log(`Fancybox element ${i}: href=`, $(this).attr('href'), 'caption=', $(this).data('caption'), 'parent classes=', $(this).closest('.slick-slide').attr('class'));
      });

      // Initialize Fancybox for v3
      $fancyboxElements.fancybox({
        loop: true,
        infobar: true,
        buttons: ['zoom', 'slideShow', 'thumbs', 'close'],
        animationEffect: 'zoom',
        transitionEffect: 'fade',
        thumbs: {
          autoStart: true, // Force thumbnails to show by default
          hideOnClose: true
        },
        clickContent: function(current, event) {
          return current.type === 'image' ? 'zoom' : false;
        },
        clickSlide: 'close',
        clickOutside: 'close',
        mobile: {
          clickContent: function(current) {
            return current.type === 'image' ? 'zoom' : false;
          },
          clickSlide: 'close',
          clickOutside: 'close',
          dblclickContent: function(current) {
            return current.type === 'image' ? 'zoom' : false;
          }
        },
        afterLoad: function(instance, slide) {
          console.log('Fancybox initialized, bound elements:', $fancyboxElements.length);
          if (instance.group.length > 1 && instance.Thumbs) {
            instance.Thumbs.show();
            console.log('Fancybox thumbs explicitly shown');
            console.log('Thumbs container styles:', $('.fancybox-thumbs').css(['display', 'visibility', 'opacity']));
          } else {
            console.log('Single image or no thumbs, Fancybox thumbs disabled');
          }
        },
        afterShow: function(instance, slide) {
          console.log('Fancybox fully ready, active slide:', slide.index);
        },
        onError: function(instance, slide, error) {
          console.error('Fancybox error:', error);
        }
      });

      // Enhanced mobile touch handler
      if (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
        $(document).on('touchstart', '.fancybox-bg, .fancybox-stage', function(e) {
          if (!$(e.target).closest('.fancybox-content, .fancybox-button').length) {
            e.preventDefault();
            $.fancybox.close();
            console.log('Fancybox closed via touch on backdrop or stage');
          }
        });
      }

      // Handle clicks on cloned slides
      $(document).on('click', '.rk_column .productView-nav .slick-cloned a.fancybox-disabled', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $cloned = $(this);
        const index = parseInt($cloned.closest('.slick-slide').data('slick-index'));
        const totalSlides = $('.rk_column .productView-nav .slick-slide:not(.slick-cloned)').length;
        const realIndex = ((index % totalSlides) + totalSlides) % totalSlides;
        console.log('Cloned slide clicked, redirecting to real slide index:', realIndex);
        const $target = $fancyboxElements.eq(realIndex);
        if ($target.length) {
          $.fancybox.open($fancyboxElements, {
            index: realIndex,
            loop: true,
            infobar: true,
            buttons: ['zoom', 'slideShow', 'thumbs', 'close']
          });
          console.log('Fancybox opened for real slide:', $target.attr('href'));
        } else {
          console.error('No matching real slide found for index:', realIndex);
        }
      });
    } catch (error) {
      console.error('Fancybox binding failed:', error);
    }
  } catch (error) {
    console.error('Slick initialization failed:', error);
  }
});